import React from 'react';
import isEmpty from 'lodash/isEmpty';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';

import PrintButton from '../Buttons/PrintButton';
import DateIntervalPicker from '../Forms/DateIntervalPicker';
import Table from './AggregateTable';
import useStyles from './styles';

const View = ({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  data,
  isBusy,
  onPrint
}) => {

  return <Grid container>
    <Grid item xs={12}>
      <AggregateHeader
        {...{startDate, setStartDate, endDate, setEndDate}}
      />
    </Grid>
    <Grid item>
      <PrintButton onClick={onPrint}/>
    </Grid>
    <Grid item xs={12}>
      <AggregateTable
        {...{isBusy, data}}
      />
    </Grid>
  </Grid>;
  ;
};

export const AggregateTable = ({
  data,
  isBusy,
}) => {

  const classes = useStyles();

  const columns = [
    { width: 150 , label: 'Valor (R$)'    , dataKey: 'value'            } ,
    { width: 130 , label: 'Distâcia (Km)' , dataKey: 'distance'         } ,
    { width: 150 , label: 'Peso (Kg)'     , dataKey: 'weight'           } ,
    { width: 130 , label: 'R$ / Km'       , dataKey: 'valuePerDistance' } ,
    { width: 100 , label: 'N Tickets'     , dataKey: 'slotCount'        } ,
    { width: 100 , label: 'N Viagens'     , dataKey: 'deliveryCount'    } ,
  ];

  return <>
    {isBusy
      ? <Grid container xs={12} justify='center'>
          <CircularProgress className={classes.spinner}/>
      </Grid>
      : !isEmpty(data)
        ? <Grid item className={classes.tableContainer}>
          <Table
            id='aggregateTable'
            {...{data, columns}}
          />
        </Grid>
        : <Grid container xs={12} justify='center'>
          <Typography variant='h6' className={classes.title}>
            Nenhum item encontrado...
          </Typography>
        </Grid>
    }
  </>;
};

export const AggregateHeader = ({
  startDate,
  endDate,
  setStartDate,
  setEndDate
}) => {

  const classes = useStyles();

  return (
    <Grid
      container
      justify='center'
      alignItems='center'
      className={classes.header}
    >
      <Grid item xs={12}>
        <DateIntervalPicker
          {...{startDate, setStartDate, endDate, setEndDate}}
        />
      </Grid>
    </Grid>
  );
};

export default View;
